import React, { useState, useEffect } from 'react';
import {Button,FormControl,InputLabel,Input,FormHelperText} from '@material-ui/core/';

import './App.css';
import Message from './Message';
import db from './firebase';
import firebase from 'firebase';
import FlipMove from 'react-flip-move'
import SendTwoToneIcon from '@material-ui/icons/SendTwoTone';
import { IconButton } from '@material-ui/core';



function App() {

  const [input,setInput] = useState("");
  const [messages,setMessages] = useState([
  ]);
  const [username,setUsername] = useState("");

  useEffect(() => {
   //run once app loads
   db.collection('messages')
   .orderBy('timestamp',"desc")
   .onSnapshot(snapshot => {
     setMessages(snapshot.docs.map(doc => ({id: doc.id, message: doc.data()})))
   })
  },[])

  useEffect(() => {
       setUsername(prompt("Please Enter Your Name"))
  },[])

  const sendMessage = (event) => {
    event.preventDefault()
   //all the logic to send message
   db.collection('messages').add({
     message: input,
     username: username,
     timestamp: firebase.firestore.FieldValue.serverTimestamp()
   })
  //  setMessages([...messages,{username: username,message: input}])
   setInput("");
  }

  return (
    <div className="App">
      <img src="https://seeklogo.com/images/F/facebook-messenger-logo-36376366E2-seeklogo.com.png" width="100" height="100" />
      <h1>Hello Clever Programmers 💬</h1>
  <h1>Welcome {username}</h1>

       <form className="app_form">
       <FormControl className="app_formControl" >
          <InputLabel >Enter a Message</InputLabel>
          <Input className="app_input"  placeholder="Enter a Message"  value={input} onChange={event => setInput(event.target.value)} />
          <IconButton
          className="app_iconButton"
          disabled={!input} variant="contained" color="primary" type="submit" onClick={sendMessage}
          >
            <SendTwoToneIcon />
          </IconButton>
      </FormControl>

       </form>
      
      <FlipMove>
          {
          messages.map(({id,message}) => (
            <Message key={id}  username={username} message={message} />
          ))
          }
      </FlipMove>
   
     
     
    </div>
  );
}

export default App;
